// src/components/translations.js

export const loadTranslations = async (language) => {
  const response = await fetch(
    `https://www.casadipinta.com/api.php?lang=${language}`
  );

  if (!response.ok) {
    throw new Error("Failed to load translations");
  }

  const data = await response.json();

  // Validate: must be a non-empty plain object (not an array, not null)
  if (!data || Array.isArray(data) || typeof data !== "object" || Object.keys(data).length === 0) {
    throw new Error(`Invalid translations received for "${language}": expected non-empty object, got ${JSON.stringify(data).slice(0, 100)}`);
  }

  return data;
};

export const saveTranslations = async (language, translations) => {
  // Pre-save validation: never send empty, null, or array data
  if (!translations || Array.isArray(translations) || typeof translations !== "object") {
    throw new Error(`Refusing to save invalid translations for "${language}": data is not an object`);
  }

  const keyCount = Object.keys(translations).length;
  if (keyCount === 0) {
    throw new Error(`Refusing to save empty translations for "${language}": object has no keys`);
  }

  // Safety check: translations should have known top-level keys
  const expectedKeys = ["nav", "home", "footer"];
  const hasExpectedKeys = expectedKeys.some((k) => k in translations);
  if (!hasExpectedKeys) {
    throw new Error(`Refusing to save translations for "${language}": missing expected keys (nav, home, footer). This looks like corrupted data.`);
  }

  const response = await fetch(`https://www.casadipinta.com/api.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ language, translations }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to save translations");
  }

  const data = await response.json();
  return data;
};
